import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { NavBar } from "../../Models/NavBar/NavBar.Model";
import ContactCenterTitle from "./Components/ContactCenterTitle/ContactCenterTitle";

const ContactCenterView = () => {
  useEffect(() => {
    NavBar.set(<ContactCenterTitle />);
  }, []);

  return (
    <div className="h-full bg-white">
      <Outlet />
    </div>
  );
};

export default ContactCenterView;
